import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import OurWork from "@/pages/OurWork";
import Impact from "@/pages/Impact";
import GetInvolved from "@/pages/GetInvolved";
import Donate from "@/pages/Donate";
import Transparency from "@/pages/Transparency";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

const TITLES = {
  "/": "Susanna Charitable Trust | Creating Meaningful Change",
  "/about": "About Us | Susanna Charitable Trust",
  "/our-work": "Our Work | Susanna Charitable Trust",
  "/impact": "Impact | Susanna Charitable Trust",
  "/get-involved": "Get Involved | Susanna Charitable Trust",
  "/donate": "Donate | Susanna Charitable Trust",
  "/transparency": "Transparency & Accountability | Susanna Charitable Trust",
  "/contact": "Contact | Susanna Charitable Trust",
  "/privacy": "Privacy Policy | Susanna Charitable Trust",
  "/terms": "Terms & Disclaimer | Susanna Charitable Trust",
};

function RouteEffects() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = TITLES[pathname] || TITLES["/"];
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <RouteEffects />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/transparency" element={<Transparency />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
